// https://github.com/henrygd/bigger-picture
// https://biggerpicture.henrygd.me/
import BiggerPicture from 'bigger-picture'

const $ = window.jQuery

const init = function() {
  const lightbox = BiggerPicture({
    target: document.body
  })

  $('[data-lightbox]').each(function(index, item) {
    const mediaSelector = '[data-toggle="lightbox"]'
    const imageLinks = item.querySelectorAll(mediaSelector)
    const openGallery = function(e) {
      e.preventDefault()
      lightbox.open({
        items: imageLinks,
        el: e.currentTarget,
      })
    }

    $(item).find(mediaSelector).each(function(mediaIndex, mediaItem){
      const $mediaItem = $(mediaItem)
      const $img = $mediaItem.find('img')
      if (!$mediaItem.attr('data-iframe')) {
        $mediaItem.attr('data-width', $img.attr('width'))
        $mediaItem.attr('data-height', $img.attr('height'))
        $mediaItem.attr('data-img', $img.attr('srcset'))
      }
      $mediaItem.attr('data-alt', $img.attr('alt'))
      $mediaItem.attr('data-thumb', $img.attr('src'))
      mediaItem.addEventListener("click", openGallery)
    })
  })
}

const destroy = function() {
  
}

export default {init, destroy}
